export default __webpack_public_path__ + "static/media/azure_devops.9f2f949a.png";